import { render, staticRenderFns } from "./AuditionCommodity.vue?vue&type=template&id=4d3d480c&scoped=true&"
import script from "./AuditionCommodity.vue?vue&type=script&lang=js&"
export * from "./AuditionCommodity.vue?vue&type=script&lang=js&"
import style0 from "./AuditionCommodity.vue?vue&type=style&index=0&id=4d3d480c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3d480c",
  null
  
)

export default component.exports